export const YEAR = 2026;
export const PRICE = 500;
export const ADDRESS = '8802 NW 9th Ave, Vancouver, WA 98665';
export const BEGIN_DATE = '15 июня (понедельник) в 10:00АМ';
export const END_DATE = '28 июня (воскресенье) в 4:00PМ';
export const EXAM_DATE = '14 июня в 12:00PМ';

export const RECOMMENDED_SONGS_URL = 'https://docs.google.com/document/d/108rs1Tda6rPWQ8M8o_GKFkWys4SbWawapbPHJD6M1qQ/edit?usp=sharing';
export const RECOMMENDATION_LETTER_URL = 'https://docs.google.com/document/d/1P2tdKnfSqzUz7jWOama95aIab1HPV_6esTPP0vpdpL0/edit?usp=sharing';
export const REGISTRATION_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSe_Pr5lm2T03LjGwBCL9nZkISpX3Ix2MVJ55FEZDEcCtiVdOw/viewform?usp=header';

export const DEACONS_CONTACT = [
  {
    name: 'Валентин Татаренко',
    linkNum: '+13603560523',
    displayNum: '+1 (360) 356-0523',
  },
  {
    name: 'Сергей Марушенко',
    linkNum: '+13605535921',
    displayNum: '+1 (360) 553-5921',
  },
];
